import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const getEnrolledObjectLabel = logEvent => {
  if (!logEvent) {
    return null;
  }
  return /*#__PURE__*/_jsx(ObjectNameLabel, {
    portalId: logEvent.portalId,
    objectId: logEvent.objectId,
    objectTypeId: logEvent.objectTypeId,
    showId: true
  });
};